"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "backgrounds", {
  enumerable: true,
  get: function get() {
    return _backgrounds["default"];
  }
});
var _backgrounds = _interopRequireDefault(require("./backgrounds"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }